module.exports = __webpack_public_path__ + "img/Robot.2a776de8.png";